import React from 'react'
import { useState, useEffect } from 'react';
import { loansdata } from '../../../../utils/JsonData/loansdata';
import { Table, Typography, Button} from 'antd';
import { getLoans } from '../../../../api/EmiPayments';
import { useSelector } from 'react-redux';
import { CURRENCY } from '../../../../utils/ConstantData';
import { CurrencyFormatWithDecimal } from '../../../../helper/CurrencyFormate';
import { TabsEnum } from '../../../../utils/Enum/ReportTabsEnum';
import { StarFilled } from "@ant-design/icons";

const Loans = ({ onClickTabChange = () => { } }) => {
  const [loans, setLoans] = useState(null);
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      width: 190
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      width: 190
    },
    {
      title: 'Particulars',
      dataIndex: 'particulars',
      key: 'particulars',
    },
    {
      title: 'Counterparty',
      dataIndex: 'counterparty',
      key: 'counterparty',
    },
    {
      title: `Debit (${CURRENCY})`,
      dataIndex: 'debit',
      key: 'debit',
      align: 'right',
      className: 'no-wrap-column',
      render: (value) => (
        <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
    ),
    },
    {
      title: `Credit (${CURRENCY})`,
      dataIndex: 'credit',
      key: 'credit',
      align: 'right',
      className: 'no-wrap-column',
      render: (value) => (
        <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
    ),
    },
    {
      title: 'Txn Count',
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      align: 'center',
      render: (value, record, index) => {
        return (parseFloat(value) > 0 ) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
    }
    },
    {
      title: 'Misses',
      dataIndex: 'misses',
      key: 'misses',
    },
  ];

  if(selectedAccountId === "all"){
    columns.unshift({
      title: "Bank Account",
      dataIndex: "accountDetails",
      key: "accountDetails",
      width: 200,
      render: value => (
        <>
        <StarFilled style={{ color: '#1890ff', marginRight: 8, marginTop: -11, fontSize: '20px' }} />
        {`${value?.bankAbbreviation} - ${value?.accountNumber.slice(8,12)} - ${value?.accountType}`}
        </>
      )
    })
  }

  useEffect(() => {

    const fetchData = async () => {
      try {
        let aggregate = selectedAccountId !== 'all'? false : true;
        let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
        const response = await getLoans(account_id, aggregate, "loans");

        const mappedData = response.loans.map((item) => ({
            ...item,
            debit: item.transactionType === "DB" ? parseFloat(item.amount) : null,
            credit: item.transactionType === "CR" ? parseFloat(item.amount) : null,
          }));

        setLoans(mappedData);

      } catch (error) {

        console.log("ERROR", error);
      }
    }

    if (selectedAccountId) fetchData();
  }, [selectedAccountId]);

  return (
    <Table
      columns={columns}
      dataSource={loans}
      pagination={{ pageSize: 100 }}
      scroll={{ x: true }}
    />
  )
}

export default Loans